module.exports = __webpack_public_path__ + "static/signature_logo-5ca8fdd18b61b80b0650385cce68fe78.gif";